/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:41
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-09-27 11:51:43
 */
import React from 'react';
import { Empty } from '@firesoon/antd';
import { EmptyPermission, EmptyTable, EmptyNormal, Empty404, EmptyNetwork } from '@firesoon/icons-react';
import { EmptyProps } from '@firesoon/antd/lib/empty/index';
import './index.less';

interface FsEmptyProps extends EmptyProps {
  /** 类型 */
  type?: 'normal' | 'table' | 'charts' | 'authority' | 'antd' | '404' | 'network';
  /** 尺寸 */
  size?: 'small';
}

const Index = (props: FsEmptyProps) => {
  const { type = 'normal', size = 'small', description = '', image, className = '', ...rest } = props;
  const empty = {
    table: {
      description: '暂无数据',
      image: <EmptyTable />,
      className: ` fs-empty-${size}`,
    },
    normal: {
      description: '暂无内容',
      image: <EmptyNormal />,
      className: ` fs-empty-${size}`,
    },
    charts: {
      description: '暂无数据',
      image: <EmptyNormal />,
      className: ` fs-empty-${size}`,
    },
    authority: {
      description: '暂无权限',
      image: <EmptyPermission />,
      className: ` fs-empty-${size}`,
    },
    '404': {
      description: '页面无法打开，请尝试刷新',
      image: <Empty404 />,
      className: ` fs-empty-${size}`,
    },
    network: {
      description: '暂无网络，请检查网络设置',
      image: <EmptyNetwork />,
      className: ` fs-empty-${size}`,
    },
    antd: {
      description,
      image,
      className: '',
    },
  };
  return (
    <Empty
      description={description || empty[type].description}
      image={image || empty[type].image}
      className={`${type !== 'antd' ? 'fs-empty' : ''}${empty[type].className || ''} ${className}`}
      {...rest}
    />
  );
};
export default Index;
